/** Indian digit grouping currency string, e.g. 123456.78 -> '₹1,23,456.78'. */
const inr = new Intl.NumberFormat("en-IN", {
  style: "currency",
  currency: "INR",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export function fmtINR(n: number | string | null | undefined): string {
  if (n === null || n === undefined || n === "") return inr.format(0);
  const num = typeof n === "string" ? Number(n) : n;
  if (!Number.isFinite(num)) return inr.format(0);
  return inr.format(num);
}

/** Plain (no currency symbol) Indian grouping, e.g. for table cells that add their own Dr/Cr styling. */
export function fmtNum(n: number | string | null | undefined): string {
  if (n === null || n === undefined || n === "") return "0.00";
  const num = typeof n === "string" ? Number(n) : n;
  if (!Number.isFinite(num)) return "0.00";
  return new Intl.NumberFormat("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(num);
}

/** 'YYYY-MM-DD' -> 'DD-MMM-YYYY' for display; passes through anything else unchanged. */
export function fmtDate(d: string | null | undefined): string {
  if (!d) return "";
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(d);
  if (!m) return d;
  const months = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
  ];
  const [, y, mo, day] = m;
  return `${day}-${months[Number(mo) - 1]}-${y}`;
}
